import cn from 'classnames'
import {useWindowSize} from 'react-use'
import {Icon} from 'src/common/Icon'

type NavigationButtonProps = {
  direction: 'prev' | 'next'
  handleClick: () => void
  disabled: boolean
}

export const NavigationButtons = ({
  handlePrev,
  handleNext,
  prevDisabled,
  nextDisabled,
}: {
  handlePrev: VoidFunction
  handleNext: VoidFunction
  prevDisabled: boolean
  nextDisabled: boolean
}) => {
  const isMobile = useWindowSize().width < 768

  if (isMobile) {
    return null
  }

  return (
    <>
      <NavigationButton direction="prev" handleClick={handlePrev} disabled={prevDisabled} />
      <NavigationButton direction="next" handleClick={handleNext} disabled={nextDisabled} />
    </>
  )
}

const NavigationButton = ({direction, handleClick, disabled}: NavigationButtonProps) => (
  <button
    onClick={handleClick}
    className={cn(
      `
      absolute
      top-[50%]
      z-10
      flex
      -translate-y-1/2
      items-center
      border
      border-grey-150
      bg-moss-white
      hover:bg-[#F1F1F1]
      hover:shadow-button
      disabled:pointer-events-none
      disabled:shadow-button
      md:rounded-md
      md:p-1
      lg:rounded-lg
      lg:p-2.5
    `,
      {
        'md:left-2.5 xl:left-0': direction === 'prev',
        'md:right-2.5 xl:right-0': direction === 'next',
      },
    )}
    disabled={disabled}
  >
    <Icon
      name="chevron"
      className={cn('md:h-4 md:w-4 lg:h-5 lg:w-5', {
        'text-[#b6b6b4]': disabled,
        'text-moss-black': !disabled,
        'rotate-90': direction === 'prev',
        'rotate-[270deg]': direction === 'next',
      })}
    />
  </button>
)
